<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">
    <h3 class="modal-title font">Previsualización de {{ entidadLabel }}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <div class="bg-second-table-info pt-3 pb-3">
      <div *ngIf="flagSearch; else messageClear" class="container-fluid">
        <div class="actions-table">
          <span class="align-middle tit-table">{{ recordsTotal }} {{ entidadLabel }} encontrados</span>
        </div>
        <div class="card-tabla-proy">
          <div class="card-body">
            <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
              <div class="datatable-container table-responsive">
                <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                  (allChecked)="allChecked($event)">
                </lib-ge-table>
                <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                  <div class="d-flex mt-2">
                    <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                      (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                    </ngb-pagination>
                  </div>
                  <div class="mt-2 selectPage">
                    <label for="itemsPerPage">Mostrar:</label>
                    <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                      <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #messageClear>
        <div class="mensaje-container">
          <p class="mensaje-linea">No se han encontrado {{ entidadLabel }}.</p>
        </div>
      </ng-template>
    </div>
    <div class="note mt-2">
      <span>{{ selectedIds.size }} {{ entidadLabelSingular }}(es) seleccionado(s)</span>
    </div>
  </div>

  <div class="modal-footer actions">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="generar()"
        aria-label="Generar"><span class="icon-add"></span>Generar</button>
    </div>
  </div>
</div>
